export interface Language {
  code: string;
  name: string;
  proficiency: string;
}

interface LanguagesSectionProps {
  speakingLanguages: Language[];
  learningLanguages: Language[];
}

const getLanguageFlag = (code: string): string => {
  const flagMap: Record<string, string> = {
    en: "🇬🇧",
    fr: "🇫🇷",
    ja: "🇯🇵",
    es: "🇪🇸",
    de: "🇩🇪",
    it: "🇮🇹",
    pt: "🇵🇹",
    ru: "🇷🇺",
    zh: "🇨🇳",
    ko: "🇰🇷",
  };

  return flagMap[code] || "🌐";
};

export default function LanguagesSection({ speakingLanguages, learningLanguages }: LanguagesSectionProps) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-semibold mb-4">Languages</h2>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-6 shadow">
          <h3 className="text-lg font-medium mb-3">Speaking</h3>
          <ul className="space-y-2">
            {speakingLanguages.map((lang) => (
              <li key={lang.code} className="flex items-center">
                <span className="mr-2 text-lg">{getLanguageFlag(lang.code)}</span>
                <span className="font-medium">{lang.name}</span>
                <span className="ml-2 text-sm text-gray-500">({lang.proficiency})</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow">
          <h3 className="text-lg font-medium mb-3">Learning</h3>
          <ul className="space-y-2">
            {learningLanguages.map((lang) => (
              <li key={lang.code} className="flex items-center">
                <span className="mr-2 text-lg">{getLanguageFlag(lang.code)}</span>
                <span className="font-medium">{lang.name}</span>
                <span className="ml-2 text-sm text-gray-500">({lang.proficiency})</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
